import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=1bc5e45b&scoped=true"
var script = {}
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=1bc5e45b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc5e45b",
  null
  
)

export default component.exports